const isVisible = shape => !(shape.get('isHidden') || shape.get('isGroupHidden'));

export default isVisible;
